export const WISHLIST_CATEGORY_OPTIONS = [
    { value: "Muebles", label: "Muebles", icon: "🛋️" },
    { value: "Tecnología", label: "Tecnología", icon: "💻" },
    { value: "Informática", label: "Informática", icon: "🖥️" },
    { value: "Celulares", label: "Celulares", icon: "📱" },
    { value: "Electrodomésticos", label: "Electrodomésticos", icon: "🔌" },
    { value: "Audio y video", label: "Audio y video", icon: "🎧" },
    { value: "Gaming", label: "Gaming", icon: "🎮" },
    { value: "Herramientas", label: "Herramientas", icon: "🛠️" },
    { value: "Hogar", label: "Hogar", icon: "🏠" },
    { value: "Cocina", label: "Cocina", icon: "🍳" },
    { value: "Decoración", label: "Decoración", icon: "🪴" },
    { value: "Iluminación", label: "Iluminación", icon: "💡" },
    { value: "Oficina", label: "Oficina", icon: "🗂️" },
    { value: "Instrumentos musicales", label: "Instrumentos musicales", icon: "🎸" },
    { value: "Ropa", label: "Ropa", icon: "👕" },
    { value: "Calzado", label: "Calzado", icon: "👟" },
    { value: "Accesorios", label: "Accesorios", icon: "🎒" },
    { value: "Automotor", label: "Automotor", icon: "🚗" },
    { value: "Moto", label: "Moto", icon: "🏍️" },
    { value: "Bicicleta", label: "Bicicleta", icon: "🚲" },
    { value: "Fitness y deporte", label: "Fitness y deporte", icon: "🏋️" },
    { value: "Libros", label: "Libros", icon: "📚" },
    { value: "Cursos", label: "Cursos", icon: "🎓" },
    { value: "Viajes", label: "Viajes", icon: "✈️" },
    { value: "Regalos", label: "Regalos", icon: "🎁" },
    { value: "Coleccionables", label: "Coleccionables", icon: "🧩" },
    { value: "Salud y bienestar", label: "Salud y bienestar", icon: "🧴" },
    { value: "Mascotas", label: "Mascotas", icon: "🐾" },
    { value: "Jardín", label: "Jardín", icon: "🌿" },
    { value: "Fotografía", label: "Fotografía", icon: "📷" },
    { value: "Cine y streaming", label: "Cine y streaming", icon: "🎬" },
    { value: "Software y licencias", label: "Software y licencias", icon: "🧩" },
    { value: "Servidores y redes", label: "Servidores y redes", icon: "🗄️" },
    { value: "Arte y manualidades", label: "Arte y manualidades", icon: "🎨" },
    { value: "Belleza y cuidado personal", label: "Belleza y cuidado personal", icon: "🧴" },
    { value: "Alimentos y bebidas", label: "Alimentos y bebidas", icon: "🛒" },
    { value: "Experiencias", label: "Experiencias", icon: "🎟️" },
    { value: "Casa / construcción", label: "Casa / construcción", icon: "🧱" },
    { value: "Bebés y niños", label: "Bebés y niños", icon: "🧸" },
    { value: "OTHER", label: "Otro / personalizado", icon: "✨" },
];

export const WISHLIST_STORE_OPTIONS = [
    { value: "Mercado Libre", label: "Mercado Libre" },
    { value: "Frávega", label: "Frávega" },
    { value: "Musimundo", label: "Musimundo" },
    { value: "Cetrogar", label: "Cetrogar" },
    { value: "Megatone", label: "Megatone" },
    { value: "Naldo", label: "Naldo" },
    { value: "On City", label: "On City" },
    { value: "Carrefour", label: "Carrefour" },
    { value: "Coto", label: "Coto" },
    { value: "Jumbo", label: "Jumbo" },
    { value: "Easy", label: "Easy" },
    { value: "Sodimac", label: "Sodimac" },
    { value: "Mercado Shops", label: "Mercado Shops" },
    { value: "Tiendanube", label: "Tiendanube" },
    { value: "Amazon", label: "Amazon" },
    { value: "AliExpress", label: "AliExpress" },
    { value: "eBay", label: "eBay" },
    { value: "Facebook Marketplace", label: "Facebook Marketplace" },
    { value: "Instagram", label: "Instagram" },
    { value: "TikTok Shop", label: "TikTok Shop" },
    { value: "Sitio oficial de la marca", label: "Sitio oficial de la marca" },
    { value: "Tienda física", label: "Tienda física" },
    { value: "Vendedor particular", label: "Vendedor particular" },
    { value: "Garbarino", label: "Garbarino" },
    { value: "Samsung", label: "Samsung" },
    { value: "Apple", label: "Apple" },
    { value: "Lenovo", label: "Lenovo" },
    { value: "Mercado Pago Point", label: "Mercado Pago / comercio" },
    { value: "Etsy", label: "Etsy" },
    { value: "Temu", label: "Temu" },
    { value: "Shein", label: "Shein" },
    { value: "Steam", label: "Steam" },
    { value: "PlayStation Store", label: "PlayStation Store" },
    { value: "Microsoft Store", label: "Microsoft Store" },
    { value: "OTHER", label: "Otro / personalizado" },
];

export const WISHLIST_CURRENCY_OPTIONS = [
    { value: "ARS", label: "Peso argentino (ARS)" },
    { value: "USD", label: "Dólar estadounidense (USD)" },
    { value: "EUR", label: "Euro (EUR)" },
    { value: "BRL", label: "Real brasileño (BRL)" },
    { value: "UYU", label: "Peso uruguayo (UYU)" },
    { value: "CLP", label: "Peso chileno (CLP)" },
    { value: "PYG", label: "Guaraní paraguayo (PYG)" },
    { value: "GBP", label: "Libra esterlina (GBP)" },
    { value: "CNY", label: "Yuan chino (CNY)" },
    { value: "CAD", label: "Dólar canadiense (CAD)" },
    { value: "AUD", label: "Dólar australiano (AUD)" },
    { value: "JPY", label: "Yen japonés (JPY)" },
    { value: "MXN", label: "Peso mexicano (MXN)" },
    { value: "COP", label: "Peso colombiano (COP)" },
    { value: "PEN", label: "Sol peruano (PEN)" },
    { value: "CHF", label: "Franco suizo (CHF)" },
    { value: "OTHER", label: "Otro / personalizado" },
];

export const WISHLIST_PRIORITY_OPTIONS = [
    { value: "LOW", label: "Baja" },
    { value: "MEDIUM", label: "Media" },
    { value: "HIGH", label: "Alta" },
    { value: "URGENT", label: "Prioritaria" },
    { value: "OPPORTUNITY", label: "Comprar si aparece oferta" },
    { value: "SOMEDAY", label: "Algún día" },
    { value: "OTHER", label: "Otro / personalizado" },
];

export const WISHLIST_PURCHASE_OPTIONS = [
    { value: "ALL", label: "Todos" },
    { value: "PENDING", label: "Pendientes" },
    { value: "PURCHASED", label: "Comprados" },
];

export const onWishlistMoney = (value, currency = "ARS") => {
    const number = Number(value || 0);
    const code = String(currency || "ARS").toUpperCase();
    try {
        return new Intl.NumberFormat("es-AR", {
            style: "currency", currency: code, maximumFractionDigits: 2,
        }).format(number);
    } catch {
        return `${code} ${number.toLocaleString("es-AR", { maximumFractionDigits: 2 })}`;
    }
};

export const onWishlistTotals = (items = [], predicate = null) => {
    const totals = {};
    items.filter((item) => !predicate || predicate(item)).forEach((item) => {
        if (item.price === null || item.price === undefined || item.price === "") return;
        const currency = String(item.currency || "ARS").toUpperCase();
        const amount = Number(item.price || 0) * Math.max(1, Number(item.quantity || 1));
        totals[currency] = (totals[currency] || 0) + amount;
    });
    return totals;
};

export const onWishlistTotalsLabel = (items = [], predicate = null) => {
    const totals = onWishlistTotals(items, predicate);
    const rows = Object.entries(totals);
    if (!rows.length) return "Sin precios";
    return rows.map(([currency, value]) => onWishlistMoney(value, currency)).join(" · ");
};

export const onWishlistPriorityLabel = (value) => ({
    LOW: "Baja",
    MEDIUM: "Media",
    HIGH: "Alta",
    URGENT: "Prioritaria",
    OPPORTUNITY: "Comprar si aparece oferta",
    SOMEDAY: "Algún día",
    OTHER: "Otra",
}[value] || value || "Media");
